import config from '@/service/config.js'
import { Message } from '@/service/toolClass.js'
let lock = false
import Vue from 'vue'
export default (method, url, params = {}, data = {}, headers = {}) => {
    if(!url) return console.error("can not find url")
    const location = window.location
    const protocol = location.protocol
    const hostname = config.api
    const version = 'v1'
    const baseURL = protocol + '//' + hostname + '/' + version
    const httpIs = url.indexOf("http") > -1
    window.axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        try {
            const errMsg = JSON.parse(JSON.stringify(error))
            if (errMsg && errMsg.response && Number(errMsg.response.status) === 403) {
                const { httpProtocol, httpHost, userCenterUrl } = config
                const lefturl = httpProtocol + '//' + userCenterUrl + '/login?redirect='
                const righturl = httpProtocol + '//' + httpHost + window.location.pathname
                if (!lock) {
                    const instance = new Message()
                    instance.closeAll()
                    instance.set("403", { type: 'error', message: Vue.prototype.$t("service/axios.js_0"), duration: 0 })
                    instance.lock = true
                    lock = true
                    // window.clearAllCookies$();
                    window.setTimeout(() => {
                        window.location.href = lefturl + righturl
                    }, 2000)
                }
                
            } else return Promise.reject(error)
        } catch (e) {
            return Promise.reject(error)
        }
        return Promise.reject(error)
    });
    return window.axios.request({ method, url, params, data, headers, baseURL: (httpIs || baseURL) })
}
